





import Vue from "vue";
import { mapState } from "vuex";
import DesktopUpload from "@/components/basic/DesktopUpload.vue";
import MobileUpload from "@/components/basic/MobileUpload.vue";

export default Vue.extend({
  name: "UploadDocumentFront",
  computed: {
    ...mapState({
      isMobile: (state: any) => state.isDetectedMobileDevice,
    }),

  },
  components: {
    DesktopUpload,
    MobileUpload
  },
});
